import type { Components, Theme } from "@mui/material/styles";

const SCREEN_BREAK = 1200;

export const MuiAppBar: Components<Theme>["MuiAppBar"] = {
  defaultProps: {
    elevation: 0,
    position: "sticky",
  },
  styleOverrides: {
    colorPrimary: ({ theme }) => ({
      backgroundColor: "transparent",
      color: theme.palette.common.white,
    }),
    root: ({ theme }) => ({
      overflowX: "clip",
      // y overflow must be visible in order to display subheader indicators
      overflowY: "visible",
      // ensure z-index is set for all position variants
      zIndex: theme.zIndex.appBar,
    }),
    positionStatic: {
      // static positioning for smaller desktop screens
      position: "static",
      // sticky when there is room
      [`@media (min-height:${SCREEN_BREAK}px)`]: {
        left: "auto",
        right: 0,
        position: "sticky",
      },
    },
  },
};
